import picture from "../img/ProfilePicture.png"
export default function ProfilePicture() {
    return <div>
        <img className="profilePicture" src={picture} alt="profile-pic"/>
    </div>
}
